var $ = jQuery;
$(document).ready(function ($) {
    // Navigation responsive
    $('#menu_trigger').on('click', function(){
        $('.navigation-wrapper').toggleClass('active');
        $('body').toggleClass('overflow-hidden')
    })

    // Mobile menu - submenu handling
    $('li.menu-item-has-children').on('click', function (event) {
        if ($(event.target).is('a, ul')) {
            return;
        }

        $(this).toggleClass('show_sub_menu');
    });
});

$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});